import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API, useAuth, apiPortraitUrl } from "@/auth";
import DailyCypherCard from "@/components/DailyCypherCard";

export default function Home() {
 const { user } = useAuth();
 const [stats, setStats] = useState({ rappers: 0, battles: 0, completed_battles: 0 });
 const [hero, setHero] = useState(null);
 const [liveRappers, setLiveRappers] = useState([]);
 const [champion, setChampion] = useState(null);
 const [arenaChamp, setArenaChamp] = useState(null);

 useEffect(() => {
 axios.get(`${API}/stats/public`).then(r => setStats(r.data)).catch(() => {});
 axios.get(`${API}/homepage/hero-video`, { validateStatus: s => s === 200 || s === 204 })
 .then(r => { if (r.status === 200) setHero(r.data); })
 .catch(() => {});
 const loadLive = () => axios.get(`${API}/rappers?sort=online&online=true&limit=10`)
 .then(r => setLiveRappers(r.data || []))
 .catch(() => setLiveRappers([]));
 loadLive();
 // Two Crowns — charts crown (best track) + arena crown (best rapper)
 axios.get(`${API}/charts/champion`).then(r => setChampion(r.data)).catch(() => {});
 axios.get(`${API}/arena/champion`).then(r => setArenaChamp(r.data)).catch(() => {});
 const iv = setInterval(loadLive, 60000);
 return () => clearInterval(iv);
 }, []);

 return (
 <div>
 {/* HERO */}
 <section className="relative overflow-hidden border-b border-yt-border">
 <div className="absolute inset-0 opacity-[0.07] pointer-events-none"
 style={{ backgroundImage: `url('https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=1920&q=70')`, backgroundSize: "cover", backgroundPosition: "center" }} />
 <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-yt-bg pointer-events-none" />

 {/* huge outline text */}
 <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
 <span className="text-stroke-white font-display text-[18vw] leading-none tracking-tighter opacity-60">RIPPEN</span>
 </div>

 <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-20 md:pt-32 pb-24 md:pb-40">
 <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
 <div className="md:col-span-8">
 <div className="inline-block border border-yt-yellow text-yt-yellow font-mono text-[10px] tracking-[0.4em] px-3 py-1.5 mb-3">
 THE ULTIMATE RAP BATTLE ARENA · PATENT PENDING
 </div>
 <div className="block font-mono text-[10px] tracking-[0.4em] text-yt-red mb-8">
 RAP BATTLES · MONTHLY CHARTS · REAL WRITERS ONLY · NO BOTS
 </div>
 <h1 className="font-display text-7xl md:text-9xl leading-[0.85] tracking-tight">
 <span className="text-yt-yellow block">YOUNG</span>
 <span className="text-yt-red block">TONGUES</span>
 </h1>
 <p className="font-body text-lg md:text-xl text-white/80 mt-8 max-w-xl">
 Step into the cypher. Drop your bars. Let <span className="text-yt-judge font-mono">JUDGE DEGAGNE</span> render the verdict on flow, rhyme, topic, punchlines, and crowd. Real-time AI rap battles — first of its kind.
 </p>
 <p className="font-body text-base text-yt-yellow/90 mt-4 max-w-xl italic border-l-2 border-yt-yellow pl-4">
 For the kid who writes bars in a notebook but freezes in front of a crowd.<br/>
 For the poet who never had cadence.<br/>
 <span className="text-white">Anyone with words can claim the mic.</span>
 </p>
 <div className="flex flex-wrap gap-4 mt-10">
 {user ? (
 <Link to="/battles/new" data-testid="hero-start-battle" className="bg-yt-yellow text-black font-display text-xl tracking-wider px-8 py-4 hover:bg-white shadow-brutal shadow-brutal-hover transition-all">
 ▶ ENTER THE ARENA
 </Link>
 ) : (
 <Link to="/register" data-testid="hero-cta-register" className="bg-yt-yellow text-black font-display text-xl tracking-wider px-8 py-4 hover:bg-white shadow-brutal shadow-brutal-hover transition-all">
 ▶ ENTER THE ARENA
 </Link>
 )}
 <Link to="/leaderboard" data-testid="hero-cta-rankings" className="border-2 border-white text-white font-display text-xl tracking-wider px-8 py-4 hover:bg-white hover:text-black transition-colors">
 VIEW RANKINGS
 </Link>
 <Link to="/how-it-works" data-testid="hero-cta-tutorial"
 className="border-2 border-yt-yellow text-yt-yellow font-display text-xl tracking-wider px-8 py-4 hover:bg-yt-yellow hover:text-black transition-colors inline-flex items-center gap-2">
 ▶ HOW IT WORKS · 60 SEC
 </Link>
 </div>
 </div>

 <div className="md:col-span-4 flex flex-col gap-4 mt-8 md:mt-0">
 <StatBlock label="RAPPERS" value={stats.rappers} testId="stat-rappers" />
 <StatBlock label="BATTLES" value={stats.battles} testId="stat-battles" />
 <StatBlock label="VERDICTS" value={stats.completed_battles} testId="stat-verdicts" />
 </div>
 </div>
 </div>
 </section>

 {/* AUTO-PLAYING FEATURED CYPHER — cold traffic hooks */}
 {/* PRE-RENDERED HERO CYPHER — single MP4, persistent storage.
 Autoplays muted (mobile-friendly), tap-to-unmute button on top. */}
 {hero && <HeroCypherVideo src={hero.video_url} poster={hero.poster_url} title={hero.title} />}

 {/* DUAL-MODE SWITCHER — introduced Feb 2026. Signals to new visitors
 that Young Tongues is a two-pillar platform: Arena (live battles,
 already shipped) + Charts (monthly community-crowned tracks, coming
 soon). Positioned above the founder story so people see WHAT the
 product is before they read WHY it exists. */}
 <ModeSwitcher isSignedIn={!!user} />

 {/* TWO CROWNS — Arena champion (best battle rapper) + Charts champion
 (top-scoring track). Ships as a paired banner so the dual-mode
 identity of Young Tongues is visible on every homepage load. */}
 {(champion || arenaChamp) && <TwoCrownsSpotlight arena={arenaChamp} charts={champion} />}

 {/* FOUNDER STORY — the human behind the app. Placed high because
 people upvote/back the person, not the feature list. */}
 <FounderStory />

 {/* LIVE RAPPERS ONLINE — social-proof strip. Encourages PvP challenges. */}
 {liveRappers.length > 0 && <LiveRappersStrip rappers={liveRappers} />}

 {/* HOW IT WORKS */}
 <section className="max-w-7xl mx-auto px-6 md:px-10 py-20">
 <div className="mb-16"><DailyCypherCard /></div>
 <h2 className="font-display text-5xl md:text-6xl tracking-tight mb-12">
 HOW IT <span className="text-yt-red">GOES DOWN</span>
 </h2>
 <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
 {[
 { n: "01", t: "BUILD YOUR RAPPER", d: "Pick your name, avatar, and lyrical style. Boom Bap, Trap, Conscious, Multisyllabic — you choose the arena." },
 { n: "02", t: "PICK YOUR OPPONENT", d: "Eight AI rappers ready in the cypher. Each with their own skill ceiling. Choose your enemy." },
 { n: "03", t: "SPIT OR GENERATE", d: "Write your bars yourself, or have Claude ghostwrite to your cadence. Either way — the verse is yours." },
 { n: "04", t: "JUDGE DEGAGNE RULES", d: "Live AI verdict on Flow, Rhyme, Topic, Punchlines, Crowd. Win → climb the bracket. Lose → train harder." },
 ].map(s => (
 <div key={s.n} className="bg-yt-surface border border-yt-border p-6 hover:border-yt-yellow transition-colors group">
 <div className="font-mono text-xs text-yt-yellow tracking-widest mb-3">{s.n}</div>
 <div className="font-display text-2xl tracking-tight mb-3 group-hover:text-yt-yellow transition-colors">{s.t}</div>
 <div className="text-sm text-white/70 leading-relaxed">{s.d}</div>
 </div>
 ))}
 </div>
 </section>

 {/* JUDGE PANEL */}
 <section className="max-w-7xl mx-auto px-6 md:px-10 py-20">
 <div className="bg-[#0A0A0A] border-l-4 border-yt-red relative scanlines">
 <div className="p-8 md:p-12">
 <div className="font-mono text-xs tracking-[0.4em] text-yt-red mb-4"> INTRODUCING</div>
 <h2 className="font-display text-5xl md:text-7xl tracking-tight text-yt-judge mb-6">JUDGE DEGAGNE</h2>
 <p className="font-mono text-yt-judge/80 max-w-2xl mb-6 text-sm leading-relaxed">
 {">"} The most theatrical, ruthless AI judge in battle rap history.<br/>
 {">"} Scores every bar on FLOW · RHYME · TOPIC · PUNCHLINES · CROWD<br/>
 {">"} Renders verdicts with full courtroom drama. No mercy.
 </p>
 <div className="border border-yt-judge/30 bg-black p-6 font-mono text-yt-judge text-sm leading-relaxed">
 <span className="text-yt-red">[VERDICT_LOG]</span> "ORDER IN THE CYPHER! That bar just committed first-degree assault on your opponent's career and I am DELIGHTED to prosecute it. PUNCHLINES: 19/20. SUSTAINED!"
 <span className="cursor-blink"></span>
 </div>
 </div>
 </div>
 </section>

 {/* PRICING TEASER */}
 <section className="max-w-7xl mx-auto px-6 md:px-10 py-20 border-t border-yt-border">
 <div className="flex items-end justify-between mb-10">
 <h2 className="font-display text-5xl md:text-6xl tracking-tight">
 CHOOSE YOUR <span className="text-yt-yellow">PASS</span>
 </h2>
 <Link to="/subscribe" className="hidden md:block font-mono text-xs tracking-widest text-yt-muted hover:text-yt-yellow">VIEW ALL TIERS →</Link>
 </div>
 <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
 <TierCard name="SPECTATOR" price="FREE" perks={["Listen to the Charts library", "Watch all battles", "Vote on battles & tracks", "View rankings"]} />
 <TierCard name="ARENA + CHARTS PASS" price="$4.99" perks={["5 rap battles / month", "UNLIMITED song drops", "Tournament eligible", "Full Judge feedback"]} highlight />
 <TierCard name="CHAMPION PASS" price="$14.99" perks={["20 rap battles / month", "UNLIMITED song drops", "Priority matchmaking", "Champion badge"]} />
 </div>
 </section>
 </div>
 );
}

function StatBlock({ label, value, testId }) {
 return (
 <div data-testid={testId} className="border border-yt-border bg-yt-surface p-5">
 <div className="font-mono text-[10px] tracking-[0.3em] text-yt-muted">{label}</div>
 <div className="font-display text-5xl tracking-tight text-yt-yellow mt-1">{value}</div>
 </div>
 );
}

function TierCard({ name, price, perks, highlight }) {
 return (
 <div className={`bg-yt-surface border p-8 transition-all ${highlight ? "border-yt-yellow shadow-brutal-yellow" : "border-yt-border hover:border-yt-yellow"}`}>
 <div className="font-mono text-xs tracking-[0.3em] text-yt-muted mb-3">{name}</div>
 <div className="font-display text-5xl tracking-tight mb-6">{price}{price !== "FREE" && <span className="text-base text-yt-muted">/mo</span>}</div>
 <ul className="space-y-2 text-sm text-white/80">
 {perks.map(p => <li key={p}>· {p}</li>)}
 </ul>
 </div>
 );
}

/* ============================================================
 HeroCypherVideo — plays the pre-rendered halftime cypher MP4.
 Single file, no live compositing. Persistent storage (survives
 redeploys). Autoplays muted, tap to unmute.
 ============================================================ */
function HeroCypherVideo({ src, poster, title }) {
 const videoRef = useRef(null);
 const [muted, setMuted] = useState(true);
 const [playing, setPlaying] = useState(false);

 useEffect(() => {
 const v = videoRef.current;
 if (!v) return;
 v.muted = true;
 v.play().then(() => setPlaying(true)).catch(() => {/* wait for tap */});
 }, [src]);

 const toggleMute = () => {
 const v = videoRef.current;
 if (!v) return;
 const next = !muted;
 v.muted = next;
 setMuted(next);
 v.play().catch(() => {});
 };

 return (
 <section data-testid="home-hero-video" className="relative border-b border-yt-border overflow-hidden bg-black">
 <div className="max-w-7xl mx-auto px-6 md:px-10 pt-8 pb-2 flex items-center justify-between flex-wrap gap-3">
 <div>
 <div className="font-mono text-xs tracking-[0.4em] text-yt-red animate-pulse-red">● HALFTIME CYPHER · AI vs AI</div>
 <div className="font-display text-3xl md:text-5xl tracking-tight mt-1 text-white">
 {title || <>WATCH A BATTLE <span className="text-yt-yellow">RIGHT NOW</span></>}
 </div>
 </div>
 <button data-testid="home-hero-unmute" onClick={toggleMute}
 className="px-4 py-2 text-sm font-mono tracking-widest border-2 border-yt-yellow text-yt-yellow hover:bg-yt-yellow hover:text-black transition-colors">
 {muted ? "TAP FOR SOUND" : "MUTE"}
 </button>
 </div>

 <div className="relative aspect-video max-w-7xl mx-auto">
 <video
 ref={videoRef}
 src={src}
 poster={poster || undefined}
 autoPlay muted loop playsInline
 preload="auto"
 className="w-full h-full object-cover"
 onCanPlay={() => setPlaying(true)}
 />
 {!playing && (
 <button onClick={toggleMute}
 className="absolute inset-0 flex items-center justify-center bg-black/60 text-white font-display text-4xl tracking-wider">
 ▶ PLAY
 </button>
 )}
 </div>
 </section>
 );
}

/* ============================================================
 TwoCrownsSpotlight — dual-crown banner. Shows both the ARENA
 crown (top rapper by monthly points) and the CHARTS crown
 (top-scoring track this month). Each crown links to /crown for
 the full celebration + share page. Auto-hides sides that don't
 yet have a champion.
 ============================================================ */
function TwoCrownsSpotlight({ arena, charts }) {
 return (
 <section data-testid="home-two-crowns" className="border-b border-yt-border bg-gradient-to-r from-yt-red/20 via-yt-surface to-yt-yellow/10">
 <div className="max-w-6xl mx-auto px-6 md:px-10 py-10 md:py-14">
 <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
 <div className="font-mono text-xs tracking-[0.4em] text-yt-yellow">
 ● TWO CROWNS · {(arena?.month || charts?.month || "").toUpperCase()}
 </div>
 <Link to="/crown" data-testid="home-crown-link"
 className="font-mono text-[10px] tracking-widest text-white border border-white px-3 py-2 hover:bg-white hover:text-black">
 SEE THE CROWN ROOM →
 </Link>
 </div>
 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
 {/* ARENA CROWN */}
 {arena ? (
 <Link to="/crown" data-testid="home-crown-arena"
 className="group border-4 border-yt-red bg-black/40 p-5 md:p-6 flex items-center gap-4 hover:bg-yt-red/20 transition-colors">
 <div className="font-display text-5xl md:text-6xl">🥊</div>
 <div className="flex-1 min-w-0">
 <div className="font-mono text-[10px] tracking-[0.4em] text-yt-red mb-1">ARENA CROWN · BATTLE KING</div>
 <div className="font-display text-2xl md:text-3xl tracking-tight leading-tight truncate">
 @{arena.rapper_name}
 </div>
 <div className="font-mono text-xs text-yt-muted mt-1">
 {arena.wins}W-{arena.losses}L · {arena.monthly_points} pts{arena.streak > 1 ? ` · 🔥${arena.streak} streak` : ""}
 </div>
 </div>
 </Link>
 ) : (
 <div className="border-2 border-dashed border-yt-red/50 bg-black/20 p-5 md:p-6 flex items-center gap-4">
 <div className="font-display text-5xl md:text-6xl opacity-40">🥊</div>
 <div className="flex-1">
 <div className="font-mono text-[10px] tracking-[0.4em] text-yt-red/60 mb-1">ARENA CROWN</div>
 <div className="font-mono text-sm text-yt-muted">Up for grabs — win a battle to claim it.</div>
 </div>
 </div>
 )}

 {/* CHARTS CROWN */}
 {charts ? (
 <Link to={`/tracks/${charts.id}`} data-testid="home-crown-charts"
 className="group border-4 border-yt-yellow bg-black/40 p-5 md:p-6 flex items-center gap-4 hover:bg-yt-yellow/10 transition-colors">
 <div className="font-display text-5xl md:text-6xl">👑</div>
 <div className="flex-1 min-w-0">
 <div className="font-mono text-[10px] tracking-[0.4em] text-yt-yellow mb-1">CHARTS CROWN · SONG KING</div>
 <div className="font-display text-2xl md:text-3xl tracking-tight leading-tight truncate">
 {charts.title.toUpperCase()}
 </div>
 <div className="font-mono text-xs text-yt-muted mt-1">
 by {charts.anonymous ? "◇ Anonymous" : `@${charts.publish_as}`} · score {charts.score >= 0 ? "+" : ""}{charts.score}
 </div>
 </div>
 </Link>
 ) : (
 <div className="border-2 border-dashed border-yt-yellow/50 bg-black/20 p-5 md:p-6 flex items-center gap-4">
 <div className="font-display text-5xl md:text-6xl opacity-40">👑</div>
 <div className="flex-1">
 <div className="font-mono text-[10px] tracking-[0.4em] text-yt-yellow/60 mb-1">CHARTS CROWN</div>
 <div className="font-mono text-sm text-yt-muted">Up for grabs — drop a track to claim it.</div>
 </div>
 </div>
 )}
 </div>
 </div>
 </section>
 );
}

/* ============================================================
 ModeSwitcher — dual-pillar homepage callout. Left card links
 into the existing Arena (rap battles), right card teases the
 upcoming Charts (monthly community-crowned tracks). This ships
 BEFORE the actual Charts feature so contest voters immediately
 see Young Tongues is a two-mode platform, not a one-trick app.
 ============================================================ */
function ModeSwitcher({ isSignedIn }) {
 return (
 <section data-testid="home-mode-switcher" className="border-b border-yt-border bg-yt-bg relative overflow-hidden">
 <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
 <div className="text-center mb-10">
 <div className="font-mono text-xs tracking-[0.4em] text-yt-yellow mb-3"> TWO STAGES · ONE PLATFORM</div>
 <h2 className="font-display text-5xl md:text-7xl tracking-tight leading-[0.9]">
 <span className="text-yt-yellow">SPIT.</span>{" "}
 <span className="text-yt-red">DROP.</span>{" "}
 <span className="text-white">CROWN.</span>
 </h2>
 <p className="font-mono text-xs md:text-sm tracking-widest text-yt-muted mt-4 max-w-2xl mx-auto">
 LIVE 1v1 RAP BATTLES + MONTHLY COMMUNITY-CROWNED TRACK CHARTS · WRITER-FIRST · NO AUTO-GEN · NO LOOP BOTS
 </p>
 </div>

 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
 {/* LEFT — The Arena (live) */}
 <Link
 to={isSignedIn ? "/battles/new" : "/register"}
 data-testid="mode-arena"
 className="group relative bg-yt-surface border-4 border-yt-yellow p-8 md:p-10 shadow-brutal hover:bg-yt-yellow hover:text-black transition-colors block"
 >
 <div className="flex items-start justify-between mb-4">
 <div className="font-mono text-[10px] tracking-[0.4em] text-yt-red group-hover:text-black"> THE ARENA · LIVE NOW</div>
 <div className="bg-yt-judge text-black font-mono text-[9px] tracking-widest px-2 py-1 animate-pulse-red">● OPEN</div>
 </div>
 <div className="font-display text-4xl md:text-6xl tracking-tight leading-[0.9] mb-4">
 RAP<br/>BATTLES
 </div>
 <ul className="font-mono text-xs md:text-sm space-y-1 text-white/80 group-hover:text-black/80 mb-6">
 <li>› 1v1 async battles — real people or AI</li>
 <li>› Judge DeGagné scores every bar</li>
 <li>› Throw the towel · climb the bracket</li>
 </ul>
 <div className="inline-block bg-black text-yt-yellow group-hover:bg-yt-red group-hover:text-white font-display text-lg tracking-widest px-5 py-3 border-2 border-yt-yellow group-hover:border-yt-red transition-colors">
 ▶ ENTER THE ARENA
 </div>
 </Link>

 {/* RIGHT — The Charts (LIVE) */}
 <Link
 to="/charts"
 data-testid="mode-charts"
 className="group relative bg-yt-surface border-4 border-yt-red p-8 md:p-10 shadow-brutal hover:bg-yt-red hover:text-white transition-colors block overflow-hidden"
 >
 <div className="flex items-start justify-between mb-4">
 <div className="font-mono text-[10px] tracking-[0.4em] text-yt-yellow group-hover:text-white"> THE CHARTS · MONTHLY CROWN</div>
 <div className="bg-yt-judge text-black font-mono text-[9px] tracking-widest px-2 py-1 animate-pulse-red">● LIVE</div>
 </div>
 <div className="font-display text-4xl md:text-6xl tracking-tight leading-[0.9] mb-4">
 LYRICAL<br/>CHARTS
 </div>
 <ul className="font-mono text-xs md:text-sm space-y-1 text-white/80 group-hover:text-white/90 mb-6">
 <li>› Bring YOUR lyrics · AI vocalizes them</li>
 <li>› Community upvotes · Judge DeGagné tie-breaks</li>
 <li>› Monthly crown · winner featured site-wide</li>
 <li>› NO auto-gen · NO loop-bot inflation</li>
 </ul>
 <div className="inline-block bg-black text-yt-red group-hover:bg-yt-yellow group-hover:text-black font-display text-lg tracking-widest px-5 py-3 border-2 border-yt-red group-hover:border-yt-yellow transition-colors">
 ▶ BROWSE THE CHARTS
 </div>
 </Link>
 </div>
 </div>
 </section>
 );
}

/* ============================================================
 FeaturedCypherHero — REMOVED (Feb 2026). Replaced by
 HeroCypherVideo which plays a pre-rendered MP4 out of
 persistent storage. No live-compositing on the homepage.
 ============================================================ */

/* ============================================================
 FounderStory — the human note. Not marketing copy: the actual
 voice of the person who built this. Kept HIGH on the page so
 visitors meet the maker before the feature list.
 ============================================================ */
function FounderStory() {
 const [expanded, setExpanded] = useState(false);
 return (
 <section data-testid="home-founder-story" className="border-b border-yt-border bg-yt-surface relative overflow-hidden">
 <div className="absolute top-0 left-0 h-2 bg-yt-red w-full pointer-events-none" />
 <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
 style={{ backgroundImage: `url('https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1920&q=70')`, backgroundSize: "cover", backgroundPosition: "center" }} />
 <div className="relative max-w-4xl mx-auto px-6 md:px-10 py-16 md:py-24">
 <div className="font-mono text-xs tracking-[0.4em] text-yt-red mb-4">✎ A NOTE FROM THE FOUNDER</div>
 <h2 className="font-display text-4xl md:text-6xl tracking-tight mb-8 leading-[0.95]">
 FROM A <span className="text-yt-yellow">TRACTOR</span><br/>TO THE <span className="text-yt-red">ARENA</span>
 </h2>

 <div className="border-l-4 border-yt-yellow pl-6 md:pl-8 space-y-6 font-body text-base md:text-lg text-white/85 leading-relaxed">

 <StoryBlock label="THE INJURY">
 A severe motor vehicle accident left me with <span className="text-yt-red">irreparable damage to the left frontal-temporal lobe of my brain</span> — a traumatic brain injury. Adrenaline dumps are hard on my heart. Doctors say I&apos;m not going to be around very long.
 </StoryBlock>

 <StoryBlock label="THE MISSION FOR MY KIDS">
 After that, everything I did was focused on one thing: leaving my children something so they can go to college when I&apos;m gone. I worked. I saved. I put together <span className="text-yt-yellow">just under $400,000</span>. That was their future.
 </StoryBlock>

 <StoryBlock label="THE SCAM">
 My first real experience on the internet was trying to invest that money in cryptocurrency — I wanted to move it faster, because I don&apos;t know how much time I have. I picked what I thought was a real investment firm. They took <span className="text-yt-red">every last dollar</span>. Almost $400,000. My kids&apos; college fund. Gone.
 </StoryBlock>

 {!expanded && (
 <button data-testid="founder-story-expand" onClick={() => setExpanded(true)}
 className="mt-2 inline-block border-2 border-yt-yellow text-yt-yellow font-mono text-xs tracking-widest px-4 py-3 hover:bg-yt-yellow hover:text-black transition-colors shadow-brutal">
 ▶ READ WHAT I DID NEXT
 </button>
 )}

 {expanded && (
 <>
 <StoryBlock label="THE SECURITY SYSTEM">
 So I built a security system. I studied exactly how those scammers operate and built the thing I wish I&apos;d had — <span className="text-yt-yellow">a system that identifies bad actors</span> before they can rob somebody else the way they robbed me. That work was obsessive. Hyper-focused, stressed, up all night.
 </StoryBlock>

 <StoryBlock label="THE LYRICS">
 While I was coding I started writing lyrics in my head as a release. I found AI music generation and made my own tracks. Then I listened to what was topping the charts and I couldn&apos;t believe it — <span className="italic">the lyrics were boring, empty, no meaning</span>. My verses hit harder. I kept thinking: <span className="italic text-white">&ldquo;I wish I could battle these guys head-to-head and let a judge decide who&apos;s actually better.&rdquo;</span>
 </StoryBlock>

 <StoryBlock label="YOUNG TONGUES">
 So I built it. And Young Tongues doesn&apos;t run on rented safety — every piece of user content flows through <span className="text-yt-yellow">my own security stack (&ldquo;Rise &amp; 9&rdquo;)</span> first. Bad actors, malware, exposure — filtered before they touch the arena. What I couldn&apos;t protect for myself, I built for everyone else.
 </StoryBlock>

 <StoryBlock label="THE ASK">
 I&apos;m a farmer. I&apos;m computer illiterate. I taught myself to code, to use AI, to use the internet — all in the middle of recovery, financial ruin, and grief. This project is what taught me all of it. If Young Tongues makes you smile, that&apos;s the vote I&apos;m asking for. And if it helps somebody&apos;s kid grab a mic instead of a scam, we win.
 </StoryBlock>
 </>
 )}
 </div>

 <div className="mt-10 flex items-center gap-4 flex-wrap">
 <div className="font-display text-2xl md:text-3xl text-yt-yellow">— PAUL</div>
 <div className="font-mono text-[10px] tracking-[0.4em] text-yt-muted">
 SOLO BUILDER · CANADA · POST-TBI · SCAMMED → BUILT THE SHIELD
 </div>
 </div>

 {expanded && (
 <div className="mt-10 flex gap-3 flex-wrap">
 <Link to="/register" data-testid="founder-cta-register"
 className="bg-yt-yellow text-black font-display text-lg tracking-wider px-6 py-3 shadow-brutal hover:bg-white">
 ▶ STAND WITH ME · ENTER THE ARENA
 </Link>
 <Link to="/subscribe" data-testid="founder-cta-subscribe"
 className="border-2 border-yt-red text-yt-red font-display text-lg tracking-wider px-6 py-3 hover:bg-yt-red hover:text-white transition-colors">
 CHIP IN · GET A PASS
 </Link>
 </div>
 )}
 </div>
 </section>
 );
}

function StoryBlock({ label, children }) {
 return (
 <div>
 <div className="font-mono text-[10px] tracking-[0.4em] text-yt-red mb-2">▪ {label}</div>
 <p>{children}</p>
 </div>
 );
}


/* ============================================================
 LiveRappersStrip — horizontal strip of rappers currently online
 (last_seen within 5 min). Hover shows a "Challenge"CTA → /rappers.
 Empty state hides the whole strip so the page doesn't look dead.
 ============================================================ */
function LiveRappersStrip({ rappers }) {
 return (
 <section data-testid="home-live-rappers" className="border-b border-yt-border bg-black">
 <div className="max-w-7xl mx-auto px-6 md:px-10 py-8">
 <div className="flex items-end justify-between mb-4 flex-wrap gap-2">
 <div>
 <div className="font-mono text-xs tracking-[0.4em] text-yt-judge animate-pulse-red">
 ● {rappers.length} RAPPER{rappers.length === 1 ? "" : "S"} ONLINE NOW
 </div>
 <div className="font-display text-3xl md:text-4xl tracking-tight mt-1">
 STEP UP · <span className="text-yt-red">CHALLENGE ONE</span>
 </div>
 </div>
 <Link
 to="/rappers"
 data-testid="home-view-all-rappers"
 className="font-mono text-xs tracking-widest border-2 border-yt-yellow text-yt-yellow hover:bg-yt-yellow hover:text-black px-4 py-2 transition-colors"
 >
 VIEW ALL ▶
 </Link>
 </div>
 <div className="flex gap-3 overflow-x-auto pb-3 -mx-1 px-1">
 {rappers.map(r => (
 <Link
 key={r.rapper_name}
 to={`/rapper/${encodeURIComponent(r.rapper_name)}`}
 data-testid={`home-live-rapper-${r.rapper_name}`}
 className="flex-shrink-0 w-32 md:w-40 bg-yt-surface border border-yt-border hover:border-yt-yellow transition-colors overflow-hidden group"
 >
 <div className="aspect-[3/4] bg-black relative overflow-hidden">
 {r.portrait ? (
 <img src={apiPortraitUrl(r.portrait)} alt={r.rapper_name}
 className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
 ) : (
 <div className="w-full h-full flex items-center justify-center font-display text-3xl text-yt-yellow">
 {(r.rapper_name || "??").slice(0, 2).toUpperCase()}
 </div>
 )}
 <div className="absolute top-2 right-2 bg-yt-judge text-black text-[9px] px-2 py-0.5 font-mono tracking-widest animate-pulse-red">
 ● LIVE
 </div>
 <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
 <div className="absolute bottom-1 left-2 right-2">
 <div className="font-display text-sm md:text-base text-white truncate">{r.rapper_name}</div>
 <div className="font-mono text-[9px] text-yt-yellow tracking-widest truncate">{r.style?.toUpperCase()}</div>
 </div>
 </div>
 <div className="px-2 py-2 flex items-center justify-between font-mono text-[10px]">
 <span className="text-yt-judge">{r.wins}W</span>
 <span className="text-yt-red">{r.losses}L</span>
 <span className="text-yt-yellow group-hover:text-white">CHALLENGE ▶</span>
 </div>
 </Link>
 ))}
 </div>
 </div>
 </section>
 );
}

